import { DotProps } from 'recharts';
import ActiveDot from 'src/components/Graph/ActiveDot';
import { getPositiveGreenColor, getNegativeRedColor } from 'src/utils/graph';
import { signDependentValue } from 'src/utils/signDependentValue';
import { getColorVar } from 'src/utils/theme/colorVars';

interface Props extends DotProps {
	value: number;
	isNeutralColor?: boolean;
}

export default function ChartActiveDot({
	cx = 0,
	cy = 0,
	value,
	isNeutralColor,
}: Props) {
	const stroke = (() => {
		if (isNeutralColor) {
			return getColorVar('button-primary-bg-hover');
		}

		return signDependentValue(value, {
			positive: getPositiveGreenColor(),
			negative: getNegativeRedColor(),
			zero: getColorVar('text-default'),
		});
	})();

	return <ActiveDot x={cx} y={cy} stroke={stroke} />;
}
